import { GetProjectsResponse } from "api/generatedApi";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Button, Typography } from "@mui/material";
import { ProjectTableRow } from "./projects-compoonents/project-row";
import { useTranslation } from "react-i18next";
import { ScreenSizeEnum, useScreenSize } from "shared/use-screen-size";
import { useProjects } from "./contexts/project-context";
import { useState } from "react";
import { useOfflineStorage } from "utils/offline-storage/use-offline-storage";

export const AccountProjects = () => {
  const { projects, refetchProjects } = useProjects();
  const { t } = useTranslation();
  const { screenSize } = useScreenSize();
  const [hideProjects, setHideProjects] = useState(true);
  const { setCurrentProjectId, getCurrentProjectId } = useOfflineStorage();
  const [primaryProject, setPrimaryProject] = useState<string | undefined>(getCurrentProjectId());

  const handlePrimaryProjectChange = (projectId: string) => {
    setCurrentProjectId(projectId);
    setPrimaryProject(projectId);
  };

  const filteredProjects =
    projects?.projects?.filter((project) => {
      if (hideProjects) {
        return !project.isHidden;
      } else {
        return project.isHidden;
      }
    }) || [];

  const handleShowHiddenProjects = () => {
    setHideProjects(!hideProjects);
    refetchProjects();
  };

  return (
    <Box sx={{ p: screenSize === ScreenSizeEnum.Mobile ? 1 : 3, color: "primary.main", height: "100vh" }}>
      <Typography variant="h5" gutterBottom color={"primary.main"}>
        {t("account.projects.title")}
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: `calc(100% - ${screenSize === ScreenSizeEnum.Mobile ? "180px" : "150px"})`,
          overflow: "auto",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: 2, marginRight: "4px" }}>
          <Button variant="contained" onClick={handleShowHiddenProjects}>
            {hideProjects ? t("account.projects.showHidden") : t("account.projects.showUnhidden")}
          </Button>
        </Box>
        <Table>
          <TableHead
            sx={{
              backgroundColor: "primary.light",
              borderRadius: "8px",
              "& .MuiTableCell-head:first-of-type": {
                borderTopLeftRadius: "8px",
              },
              "& .MuiTableCell-head:last-of-type": {
                borderTopRightRadius: "8px",
              },
            }}
          >
            <TableRow>
              <TableCell sx={{ color: "primary.main" }}>{t("account.projects.name")}</TableCell>
              {screenSize != ScreenSizeEnum.Desktop && screenSize != ScreenSizeEnum.Mobile && <TableCell sx={{ color: "primary.main" }}>{t("account.projects.currentUserRole")}</TableCell>}
              {screenSize != ScreenSizeEnum.Desktop && screenSize != ScreenSizeEnum.Mobile && <TableCell sx={{ color: "primary.main" }}>{t("account.projects.company")}</TableCell>}
              <TableCell sx={{ color: "primary.main" }}>{t("account.projects.akkordsum")}</TableCell>
              <TableCell sx={{ color: "primary.main" }}>{t("account.projects.hideProject")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredProjects.length > 0 ? (
              filteredProjects.map((project) => <ProjectTableRow key={project.projectId ?? ""} primaryProject={primaryProject} project={project} isHidden={project.isHidden ?? false} setAsPrimary={handlePrimaryProjectChange} />)
            ) : (
              <TableRow>
                <TableCell colSpan={5}>{hideProjects ? t("account.projects.noVisibleProjects") : t("account.projects.noHiddenProjects")}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
